
/* Category management moved to a separate service - commented out.
export function LoadEditCategory(categoryID, categoryName, sortOrder, isPublic, parentID) {
    $("#hdnCategoryID").val(categoryID);
    $("#txtCategoryName").val(categoryName.split("&#39;").join("'"));
    $("#txtSortOrder").val(sortOrder);
    if (isPublic.toLowerCase() == "true") {
        $("#rdoIsPublic").attr("checked", true);
    } else {
        $("#rdoIsPublic").attr("checked", false);
    }

    if (parentID == "-1") {
        parentID = "";  //this is the value needed to display the default option in the drop down list
    }
    $("#ddlParentCategory").val(parentID);
    $(".category-form-title").html("Edit Category");

    $(".create-new-category").removeClass("d-none").addClass("d-flex");
    $("#btnCategoryDelete").show();

    $('html,body').animate({
        scrollTop: $(".create-edit-form").offset().top
    }, 'fast');
}

export function CreateFormToggle() {
    ResetForm();
    $(".category-form-title").html("Add New Category");

    $(".create-new-category").removeClass("d-flex").addClass("d-none");
    $("#btnCategoryDelete").hide();
}

function ResetForm() {
    $("#hdnCategoryID").val("");
    $("#txtCategoryName").val("");
    $("#txtSortOrder").val(0);
    $("#rdoIsPublic").attr("checked", false);
    $("#ddlParentCategory").val("");
}

export function SaveCategory() {
    $("#btnCategorySave").attr("disable", true);
    $("#btnCategoryDelete").attr("disable", true);
    $(".articles.loadingContainer").show();

    var categoryID = $('#hdnCategoryID').val();
    var categoryName = $('#txtCategoryName').val();
    var sortOrder = $('#txtSortOrder').val();
    var isPublic = $('#rdoIsPublic').is(':checked');
    var parentID = $('#ddlParentCategory').val();
    if (parentID == null || parentID == "") {
        parentID = -1;  //this is the default value of no parent
    }

    //if the ID is not set, create a new category
    if (categoryID == null || categoryID == 0 || categoryID == "") {
        $.ajax({
            url: articleBaseUrl() + "/AlliedPilots" + "/Articles/CreateCategory",
            type: 'POST',
            data: { Name: categoryName, SortOrder: sortOrder, IsPublic: isPublic, ParentID: parentID },
            dataType: 'text',
            success: function (response) {
                $(".articles.loadingContainer").hide();
                $("#btnCategorySave").removeAttr("disabled");
                $("#btnCategoryDelete").removeAttr("disabled");

                if (response.toLowerCase() == "false") {
                    alert("There was a problem saving the category. Try refreshing to re-input the details");
                } else {
                    alert("Created Successfully");
                    ResetForm();
                    window.location.href = "/Services/Category-Management";
                }
            },
            error: function (response) {
                $(".articles.loadingContainer").hide();
                $("#btnCategorySave").removeAttr("disabled");
                $("#btnCategoryDelete").removeAttr("disabled");

                alert("There was a problem saving the category. Try refreshing to re-input the details");
            }
        });
    } else {
        //otherwise, edit the existing category
        $.ajax({
            url: articleBaseUrl() + "/AlliedPilots" + "/Articles/SaveCategory",
            type: 'POST',
            data: { Name: categoryName, SortOrder: sortOrder, IsPublic: isPublic, CategoryID: categoryID, ParentID: parentID },
            dataType: 'text',
            success: function (response) {
                $(".articles.loadingContainer").hide();
                $("#btnCategorySave").removeAttr("disabled");
                $("#btnCategoryDelete").removeAttr("disabled");

                if (response.toLowerCase() == "false") {
                    alert("There was a problem saving the category. Try refreshing to re-input the details");
                } else {
                    alert("Updated Successfully");
                    ResetForm();
                    window.location.href = "/Services/Category-Management";
                }
            },
            error: function (response) {
                $(".articles.loadingContainer").hide();
                $("#btnCategorySave").removeAttr("disabled");
                $("#btnCategoryDelete").removeAttr("disabled");

                alert("There was a problem saving the category. Try refreshing to re-input the details");
            }
        });
    }
}

export function DeleteCategory() {
    $("#btnCategorySave").attr("disable", true);
    $("#btnCategoryDelete").attr("disable", true);
    $(".articles.loadingContainer").show();

    var catID = $('#hdnCategoryID').val();
    $.ajax({
        url: articleBaseUrl() + "/AlliedPilots" + "/Articles/DeleteCategory",
        type: 'POST',
        data: { CategoryID: catID },
        dataType: 'text',
        success: function (response) {
            $(".articles.loadingContainer").hide();
            $("#btnCategorySave").removeAttr("disabled");
            $("#btnCategoryDelete").removeAttr("disabled");

            if (response.toLowerCase() == "false") {
                alert("There was a problem deleting the category. Refresh the page if you would like to try again.");
            } else {
                alert("Deleted Successfully");
                ResetForm();
                window.location.href = "/Services/Category-Management";
            }
        },
        error: function (response) {
            $(".articles.loadingContainer").hide();
            $("#btnCategorySave").removeAttr("disabled");
            $("#btnCategoryDelete").removeAttr("disabled");

            alert("There was a problem deleting the category. Refresh the page if you would like to try again.");
        }
    });
}
*/

function articleBaseUrl() {
    return window.location.protocol + "//" + window.location.host;
}

export function toggleCategories() {
    if ($(".dashboard-categories-view").hasClass('d-none'))
    {
        $(".dashboard-categories-view").addClass('col-lg-3').addClass('col-md-4').addClass('col-sm-5').addClass('col-12');
        $(".dashboard-categories-view").removeClass('d-none');
        $("#btnToggleCategories").html("Hide Categories");
        $("#btnToggleCategories").addClass("active");
    } else {
        $(".dashboard-categories-view").removeClass('col-lg-3').removeClass('col-md-4').removeClass('col-sm-5').removeClass("col-12");
        $(".dashboard-categories-view").addClass('d-none');
        $("#btnToggleCategories").html("Show Categories");
        $("#btnToggleCategories").removeClass("active");
    }
}